/*=========================================================================================
  File Name: moduleSparepart.js
  Description: sparepart Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleSparepartState.js";
import mutations from "./moduleSparepartMutations.js";
import actions from "./moduleSparepartActions.js";
import getters from "./moduleSparepartGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
